import { render, staticRenderFns } from "./OrionSync.vue?vue&type=template&id=ad95e962&"
import script from "./OrionSync.vue?vue&type=script&lang=js&"
export * from "./OrionSync.vue?vue&type=script&lang=js&"
import style0 from "./OrionSync.vue?vue&type=style&index=0&id=ad95e962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports